const riot = require('riot');

riot.tag2('modal-email', '<div class="modal bg-white w472 s-w-full p16 rounded-8" ref="modal"> <div class="text-background_dark_primary fs16 lh15 bold mb16">{getLabels().title}</div> <div class="mb32"> <p class="fs12">{getLabels().description}</p> <p class="fs12 pt8" if="{getLabels().annotation}">{getLabels().annotation}</p> </div> <form onsubmit="{onSubmit}"> <label class="block lh15 mb12"> <div class="fs10 lh13 mb6">{getLabels().email}</div> <input class="input large light_secondary w-full text-label_dark_medium" ref="email" required type="email"> </label> <label class="block lh15 mb32"> <div class="fs10 lh13 mb6">{getLabels().password}</div> <input class="input large light_secondary w-full text-label_dark_medium" ref="password" type="password" required> </label> <div class="text-center"> <button class="button primary hover-pale w220">{getLabels().button}</button> </div> </form> </div>', 'modal-email,[data-is="modal-email"]{background-color:rgba(0,0,0,0.5)}', 'class="f fh s-px8" spat-animation="push"', function(opts) {
    this.on('mount', () => {

      this.isEmailLinked = app.auth.currentUser.providerData.some(
        (p) => p.providerId === 'password'
      );
      this.update();
    });

    this.getLabels = () =>  {

      if (this.isEmailLinked) {
        return {
          title: 'メールアドレスを変更',
          description: '新しく設定するメールアドレスと現在のパスワードを入力してください',
          password: '現在のパスワードを入力してください',
          annotation: '',
          email: '新しいメールアドレスを入力してください',
          button: '変更',
        };
      }

      else {
        return {
          title: 'メールアドレスを連携',
          description: '連携したいメールアドレスとパスワードを入力してください',
          password: '新規パスワードを入力してください',
          annotation: '※Google連携されている場合は、次のステップで連携済みのGoogleアカウントを選択してください',
          email: '新しいメールアドレスを入力してください',
          button: '連携',
        };
      }
    }

    this.onSubmit = async (e) => {
      e.preventDefault();

      const new_email = this.refs.email.value;
      const password = this.refs.password.value;
      const user = app.auth.currentUser;

      try {

        if (this.isEmailLinked) {

          const credential = firebase.auth.EmailAuthProvider.credential(
            user.email,
            password
          );

          await user.reauthenticateWithCredential(credential);

          await user.updateEmail(new_email);
          await spat.modal.alert('メールアドレスを更新しました');
        }

        else {

          const provider = new firebase.auth.GoogleAuthProvider();
          await user.reauthenticateWithPopup(provider);

          const credential = firebase.auth.EmailAuthProvider.credential(
            new_email,
            password
          );

          await user.linkWithCredential(credential);

          await spat.modal.alert('メールアドレス連携が完了しました');
        }

        await app.api.child('me').put({});
        this.close();
      } catch (err) {
        console.error('メール連携エラー:', err);
        await spat.modal.alert('エラーが発生しました');
      }
    };
});